import style from "./loader.module.scss";

const Loader = ({ small }: any) => {
  return (
    <div className={[style.loader, small ? style.small : null].join(" ")}></div>
  );
};

export default Loader;
